<div class="pre-post-op-control-main" [ngStyle]="{'height' : isExpanded ? '100%' : '42px'}" data-cy="tdo-pre-post-op-control">
  <div class="pre-post-op-control-item" cdkDropList
       appDragFileToBrowser (files)="onFilesDropped($event, 'preop')"
       (cdkDropListDropped)="onPreOpDropped($event)"
       [ngClass]="{'pre-post-op-control-selected-item': isSelectedItem('preop')}"
       (contextmenu)="onRightMouseClick($event,'Pre Op', 'preop'); false"
       (mouseover)="onItemMouseOver('preop')"
       (mouseout)="onItemMouseOut('preop')"
       style="margin-right: 1px;" data-cy="tdo-pre-post-op-preop-item">
    <div *ngIf="(isMouseOver || !preopImageSrc) && isExpanded" style="position: absolute; left: 4px; color: var(--tdo-primary-accent); font-weight: 500; " data-cy="tdo-pre-post-op-preop-label">Pre Op</div>
    <div *ngIf="preopDocs.length > 1 && preopIndex > 0" (click)="preopIndex = preopIndex - 1; false" style="position: absolute; bottom: 0; cursor: pointer; color: var(--tdo-primary-accent);" data-cy="tdo-pre-post-op-preop-prev">
      <mat-icon>chevron_left</mat-icon>
    </div>
    <div *ngIf="preopDocs.length > 1 && preopIndex < preopDocs.length - 1" (click)="preopIndex = preopIndex + 1; false" style="position: absolute; bottom: 0; right: 0; cursor: pointer; color: var(--tdo-primary-accent);" data-cy="tdo-pre-post-op-preop-next">
      <mat-icon>chevron_right</mat-icon>
    </div>
    <div style="width: 100%; height: 100%;" (dblclick)="onDoubleClick('preop')" data-cy="tdo-pre-post-op-preop-container">
      <div *ngIf="preopDocs.length == 0" style="text-align: center; height: 100%; width: 100%;" data-cy="tdo-pre-post-op-preop-empty">
        <img src="assets/Images/icons8-mouse-right-click.svg" style="position: relative; top: 50%; transform: translateY(-50%); margin-left: auto; margin-right: auto;" data-cy="tdo-pre-post-op-preop-empty-icon" />
      </div>
      <div *ngIf="preopDocs.length > 0" style="width: 100%; height: 100%;" data-cy="tdo-pre-post-op-preop-content">
        <img [src]="getImageSource('preop')"  style="max-width: 100%; max-height: 100%;  border-radius: 6px;" data-cy="tdo-pre-post-op-preop-image" />
      </div>
    </div>
  </div>


  <div class="pre-post-op-control-item" cdkDropList
       appDragFileToBrowser (files)="onFilesDropped($event, 'postop')"
       (cdkDropListDropped)="onPostOpDropped($event)"
       [ngClass]="{'pre-post-op-control-selected-item': isSelectedItem('postop')}"
       (contextmenu)="onRightMouseClick($event,'Post Op', 'postop'); false"
       (mouseover)="onItemMouseOver('postop')"
       (mouseout)="onItemMouseOut('postop')"
       style="margin-right: 1px;" data-cy="tdo-pre-post-op-postop-item">
    <div *ngIf="(isMouseOver || !postopImageSrc) && isExpanded" style="position: absolute; left: 4px; color: var(--tdo-primary-accent); font-weight: 500; " data-cy="tdo-pre-post-op-postop-label">Post Op</div>
    <div *ngIf="postopDocs.length > 1 && postopIndex > 0" (click)="postopIndex = postopIndex - 1; false" style="position: absolute; bottom: 0; cursor: pointer; color: var(--tdo-primary-accent);" data-cy="tdo-pre-post-op-postop-prev">
      <mat-icon>chevron_left</mat-icon>
    </div>
    <div *ngIf="postopDocs.length > 1 && postopIndex < postopDocs.length - 1" (click)="postopIndex = postopIndex + 1; false" style="position: absolute; bottom: 0; right: 0; cursor: pointer; color: var(--tdo-primary-accent);" data-cy="tdo-pre-post-op-postop-next">
      <mat-icon>chevron_right</mat-icon>
    </div>
    <div style="width: 100%; height: 100%;" (dblclick)="onDoubleClick('postop')" data-cy="tdo-pre-post-op-postop-container">
      <div *ngIf="postopDocs.length == 0" style="text-align: center; height: 100%; width: 100%;" data-cy="tdo-pre-post-op-postop-empty">
        <img src="assets/Images/icons8-mouse-right-click.svg" style="position: relative; top: 50%; transform: translateY(-50%); margin-left: auto; margin-right: auto;" data-cy="tdo-pre-post-op-postop-empty-icon" />
      </div>
      <div *ngIf="postopDocs.length > 0" style="width: 100%; height: 100%;" data-cy="tdo-pre-post-op-postop-content">
        <img [src]="getImageSource('postop')" style="max-width: 100%; max-height: 100%; border-radius: 6px;" data-cy="tdo-pre-post-op-postop-image" />
      </div>
    </div>
  </div>
</div>

<ng-template #pasteMenu let-data>
  <section class="image-context-menu" data-cy="tdo-pre-post-op-context-menu">
    <div *ngIf="isPasteableData()" (click)="onPaste(data)" class="item" data-cy="tdo-pre-post-op-context-paste">Paste</div>
    <div (click)="openAll(data)" class="item" data-cy="tdo-pre-post-op-context-open-all">Open all {{lastItemName}}</div>
    <div (click)="onAcquire(data)" class="item" data-cy="tdo-pre-post-op-context-acquire">Acquire</div>
    <div (click)="onRemoveAssociation(data)" class="item" data-cy="tdo-pre-post-op-context-remove">Remove</div>
    <div *ngIf="isDesktopAcquire" (click)="onAcquire(data)" class="item" data-cy="tdo-pre-post-op-context-desktop-acquire">Acquire</div>
  </section>
</ng-template>
